<template>
  <div :class="$style.wrap">
    <!-- 查询 -->
    <template v-if="active == 0">
      <base-form
        :currentIndex="active"
        @giveData="giveData"
        ref="form"
        label-width="6em"
        :items="data"
        @submit="onSubmit"
        submit-text="下一步"
        @showTip="handlerOrderTip"
      />
      <p :class="$style.appeal" @click="goPath">账号申诉</p>
    </template>
    <!-- 申诉结果 -->
    <template v-else>
      <template v-if="active != 2">
        <div :class="['tip_wrap', $style.text]">
          <tip-icon :iconName="resultsInfo.iconName" />
          <div :class="$style.rightContent">
            <h3>{{ resultsInfo.tipText }}</h3>
          </div>
        </div>
        <div :class="$style.info" v-html="resultsInfo.tipHtml"></div>
      </template>
      <p :class="$style.reset_tip" v-else>
        以下信息将成为您的新安全信息，请谨慎填写
      </p>
      <!-- 申诉  1-通过  -->
      <base-form
        v-if="queryResults == 1"
        :has-captcha="false"
        :currentIndex="active"
        :items="data"
        ref="form"
        label-width="4em"
        submit-text="确定"
        @giveData="giveData"
        @submit="onSubmit"
        @showTip="handlerOrderTip"
      />
      <!-- 申诉 0-处理中  2-未通过 -->
      <van-button
        :class="$style.result_button"
        v-else
        round
        type="primary"
        size="large"
        tag="input"
        :value="resultsInfo.buttonName"
        native-type="submit"
        @click.stop.prevent="onSubmit"
      />
    </template>
    <!-- 提示 -->
    <p :class="$style.tip" v-show="tipShow">
      申诉提交成功后，您的手机将收到已受理的提示短信，里面包含此次申诉的工单号。
    </p>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { queryAppeal, doResetInfo, getResetInfo } from "@/http/serve";
import { minxinActive } from "@/mixins/minxinActive";
import BaseForm from "@/components/BaseForm";
import tipIcon from "../components/TipIcon";
export default {
  name: "CustomerService",
  data() {
    return {
      active: this.$ls.get("active", 0), //控制显示
      resetItems: {
        //重置项id
        1: { name: "newPassword" },
        4: { name: "bindEmail" },
        5: { name: "bindPhone" }
      },
      tel: this.$ls.get("tel", ""), //手机号码
      queryResults: this.$ls.get("queryResults", 0), //0-处理中  1-通过 2-未通过
      tipShow: false, //是否提示工单含义
      dataList: this.$ls.get("dataList") || [
        {
          title: "第一步",
          filed: [
            { name: "userAccount" },
            {
              name: "appealNumber",
              iconType: 2
            }
          ]
        },
        {
          title: "第二步",
          filed: [
            {
              name: "telCode",
              moduleType: true,
              type: 30
            }
          ]
        },
        {
          title: "第三步",
          filed: []
        }
      ]
    };
  },
  components: {
    BaseForm,
    tipIcon
  },
  mixins: [minxinActive],
  mounted() {
    this.SetLeave(false);
  },
  computed: {
    data() {
      return this.dataList[this.active].filed;
    },
    resultsInfo() {
      let resultList = {
        "0": {
          iconName: "wait",
          tipText: "申诉正在处理中，请耐心等待",
          tipHtml:
            "<p>我们将会把申诉审核结果发往您的联系手机，请注意查收。</p>",
          buttonName: "继续查询"
        },
        "1": {
          iconName: "small",
          tipText: "申诉已成功通过审核",
          tipHtml: `<p>待验证手机号：${this.tel}</p><p>请输入手机验证码完成验证后重置安全信息。</p>`
        },
        "2": {
          iconName: "cry",
          tipText: "真遗憾，申诉没有通过审核",
          tipHtml:
            "<p> 可能因为：</p> <p>1、提供的截图不清晰或者有PS痕迹，我们无法分辨； <p>2、提交的身份证信息与账号实名认证信息不一致；</p>  <p>3、如有疑问，请联系客服。</p>",
          buttonName: "重新提交申诉"
        }
      };
      return resultList[this.queryResults];
    }
  },
  watch: {
    active: {
      handler(val) {
        if (val === 1) {
          this.$parent.showBack = false;
        } else {
          this.$parent.showBack = true;
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(["SetLeave"]),
    /**
     * @description 前往账号申诉
     */
    goPath() {
      this.SetLeave(true);
      this.$router.replace({ path: this._anchor.appealSubmit.path });
    },
    /**
     * @description 页面步骤回退
     */
    goBack() {
      if (this.active === 2) {
        this.$Toast({
          message: "返回上一步需重新验证手机",
          onClose: () => {
            this.dataList[2].filed = [];
            this.$ls.set("dataList", this.dataList);
            this.resetFieldValue(1, "telCode");
            this.backActive();
          }
        });
        return false;
      } else if (this.active === 1) {
        this.queryResults = "";
        this.$ls.set("queryResults", "");
        this.resetFieldValue(1, "telCode");
        this.backActive();
        return false;
      } else if (this.active == 0) {
        this.removeAll();
      }
      return true;
    },
    /**
     * @description 查询结果执行事件
     * @param {object} formdata  - 表单对象值
     */
    setResultsEvent(formdata) {
      //申诉处理中 按钮-继续查询
      if (this.queryResults == 0) {
        this.backActive();
        this.queryResults = "";
        this.$ls.set("queryResults", "");
        this.resetFieldValue(0, "userAccount");
        this.resetFieldValue(0, "appealNumber");
        this.$router.replace({ path: this._anchor.appealFind.path });
      }
      //申诉通过
      if (this.queryResults == 1) {
        //获取重置项
        this.getResetInfo(formdata);
      }
      //申诉未通过 按钮-重新去提交
      if (this.queryResults == 2) {
        this.SetLeave(true);
        this.$router.replace({ path: this._anchor.appealSubmit.path });
      }
    },
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      if (this.active == 0) {
        this.queryOrder(formdata);
      } else if (this.active == 1) {
        this.setResultsEvent(formdata);
      } else if (this.active == 2) {
        this.setResetInfo(formdata);
      }
    },
    /**
     * @description 获得可重置的项
     * @param {object} formdata  - 表单对象值
     */
    async getResetInfo(formdata) {
      let { telCode } = formdata;
      let parmas = {
        code: telCode,
        login_code: this.getFieldValue(0, "userAccount"),
        w_id: this.getFieldValue(0, "appealNumber")
      };
      let res = await getResetInfo(parmas);
      let { rcode, data } = res;
      if (rcode != 0) {
        rcode == 6002 ? this.resetData() : this.handlerForm();
        return false;
      }
      let { items } = data;

      items.map(item => {
        return this.dataList[2].filed.push(this.resetItems[item]);
      });
      this.$ls.set("dataList", this.dataList);
      this.setActive();
      this.handlerForm();
    },
    /**
     * @description 重置可重置的项
     * @param {object} formdata  - 表单对象值
     */
    async setResetInfo(formdata) {
      let { newPassword, bindEmail, bindPhone } = formdata;
      let parmas = {
        w_id: this.getFieldValue(0, "appealNumber"),
        password: newPassword,
        bind_email: bindEmail,
        bind_tel: bindPhone
      };
      let res = await doResetInfo(parmas);
      let { rcode, rdesc } = res;
      if (rcode != 0) {
        rcode == 6002 ? this.resetData() : this.handlerForm();
        return false;
      }

      this.handlerForm();
      this.$Toast({
        message: rdesc,
        onClose: () => {
          this.SetLeave(true);
          this.$router.replace({ path: this._anchor.gameHome.path });
        }
      });
    },
    /**
     * @description 查询工单账号
     * @param {object} formdata  - 表单对象值
     */
    async queryOrder(formdata) {
      let { userAccount, appealNumber } = formdata;
      let parmas = {
        login_code: userAccount,
        w_id: appealNumber
      };
      let res = await queryAppeal(parmas);
      let { rcode, data } = res;
      if (rcode != 0) {
        rcode == 6002 ? this.resetData() : this.handlerForm();
        return false;
      }
      this.queryResults = data.status;
      this.setFieldValue(0, "appealNumber", appealNumber);
      this.setFieldValue(0, "userAccount", userAccount);
      this.$ls.set("queryResults", this.queryResults);
      if (this.queryResults == 1) {
        this.tel = data.s_tel;
        this.$ls.set("tel", this.tel);
        this.setFieldValue(1, "telCode", data.tel, "phone");
      }
      this.handlerForm();
      this.setActive();
    },
    /**
     * @description 控制申诉工单号提示
     */
    handlerOrderTip() {
      this.tipShow = !this.tipShow;
      let timer = setTimeout(() => {
        clearInterval(timer);
        this.tipShow = false;
      }, 3000);
    },
    /**
     * @description 重置页面数据变为初始值
     */
    resetData() {
      this.handlerForm();
      this.queryResults = "";
      this.$ls.set("queryResults", "");
      this.active = 0;
      this.$ls.set("active", 0);
      this.dataList = [
        {
          title: "第一步",
          filed: [
            { name: "userAccount" },
            {
              name: "appealNumber",
              iconType: 2
            }
          ]
        },
        {
          title: "第二步",
          filed: [
            {
              name: "telCode",
              moduleType: true,
              type: 30
            }
          ]
        },
        {
          title: "第三步",
          filed: []
        }
      ];
      this.$ls.set("dataList", this.dataList);
    },
    /**
     * @description 移除存储数据
     */
    removeAll() {
      let lsList = ["queryResults", "resetId", "dataList", "active"];
      this.lsRemove(lsList);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  .flex-col;
  .flex-center;
  position: relative;
  padding-top: 1.1rem;
  :global {
    .van-field__right-icon {
      color: #48d5af;
    }
    .van-field__left-icon .van-icon,
    .van-field__right-icon .van-icon {
      font-size: 22px;
    }
    .van-button--small {
      background-color: transparent;
      color: #48d5af;
    }
  }
  .tip {
    width: 6rem;
    position: absolute;
    top: 3.3rem;
    right: 0.5rem;
    font-size: 0.28rem;
    line-height: 0.48rem;
    color: #222222;
    background-color: #ffffff;
    box-shadow: 0rem 0.09rem 0.16rem 0rem rgba(14, 5, 10, 0.06);
    border-radius: 0.1rem;
    padding: 0.3rem;
    &:before {
      content: "";
      position: absolute;
      right: 0.1rem;
      bottom: 100%;
      color: #fff;
      border: 0.12rem solid transparent;
      border-bottom-width: 0.12rem;
      border-bottom-color: currentColor;
    }
  }
  .text,
  .info,
  .reset_tip {
    .size(6.4rem, auto);
  }
  .reset_tip,
  .info {
    font-size: 0.3rem;
    color: #222222;
  }
  .text {
    margin: 0.44rem 0rem 0.53rem 0rem;
    justify-content: flex-start;
  }
  .reset_tip {
    margin-top: 0.4rem;
  }

  .result_button {
    margin-top: 0.76rem;
  }
  form {
    width: 100%;
    margin-top: 0.4rem;
  }
}
.appeal {
  display: block;
  font-size: 0.3rem;
  color: #818181;
  text-align: center;
  text-decoration: underline;
  margin-top: 0.5rem;
}
</style>
